import Vue from 'vue'
import axios from '@/http-common'

import { COMUNIDADES_REQUEST, COMUNIDADES_ERROR, COMUNIDADES_SUCCESS, COMUNIDADES_ACTIVATE } from '../actions/comunidades'
import { PROPIEDADES_REQUEST } from '../actions/propiedades'
import { CARPETAS_REQUEST } from '../actions/documentos'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { 
  status: '', 
  comunidades: [],
  idComunidadActiva: 0
}

const getters = {
  idComunidadActiva: state => state.idComunidadActiva
}

const actions = {
  [COMUNIDADES_REQUEST]: ({commit, dispatch}) => {
    commit(COMUNIDADES_REQUEST)
    axios.get('/comunidades', {})
      .then(response => {
        commit(COMUNIDADES_SUCCESS, response.data)

        if (state.idComunidadActiva != 0) {
          dispatch(COMUNIDADES_ACTIVATE, state.idComunidadActiva)   
        }
        else {
          dispatch(COMUNIDADES_ACTIVATE, response.data[0].IDCOMUNIDAD)   
        }
      })
      .catch(() => {
        commit(COMUNIDADES_ERROR)
      })
  },
  [COMUNIDADES_ACTIVATE]: ({commit, dispatch}, idComunidad) => {
      commit(COMUNIDADES_ACTIVATE, idComunidad)

      dispatch(PROPIEDADES_REQUEST, { idComunidad: idComunidad })
      dispatch(CARPETAS_REQUEST, { idComunidad: idComunidad })
  }
}

const mutations = {
  [COMUNIDADES_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [COMUNIDADES_SUCCESS]: (state, resp) => {
    state.status = 'success'
    
    Vue.set(state, 'comunidades', resp)

    //state.idComunidadActiva = resp[0].IDCOMUNIDAD
  },
  [COMUNIDADES_ERROR]: (state) => {
    state.status = 'error'
  },
  [COMUNIDADES_ACTIVATE]: (state, idComunidad) => {
    state.idComunidadActiva = idComunidad
  },
  [AUTH_LOGOUT]: (state) => {
    state.comunidades = []
    state.idComunidadActiva = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
